import {
  CoBrandingLogoContent,
  CoBrandingLogoPartnershipExplained,
  CoBrandingLogoReceipt,
  CoBrandingLogoSidebar,
} from '@insify/funnel-components';

import { useCoBranding } from '../hooks/useCoBranding';

type CoBrandingProps = React.ComponentProps<typeof CoBrandingLogoSidebar>;

const withCoBranding =
  (Component: React.ComponentType<CoBrandingProps>) => (props: Omit<CoBrandingProps, 'branding'>) => {
    const { branding } = useCoBranding();
    return <Component {...props} branding={branding} />;
  };

const logoSidebar = withCoBranding(CoBrandingLogoSidebar);

const LogoContent = withCoBranding(CoBrandingLogoContent);

const LogoReceipt = withCoBranding(CoBrandingLogoReceipt);

const LogoPartnershipExplained = withCoBranding(CoBrandingLogoPartnershipExplained);

export {
  logoSidebar as CoBrandingLogoSidebar,
  LogoContent as CoBrandingLogoContent,
  LogoReceipt as CoBrandingLogoReceipt,
  LogoPartnershipExplained as CoBrandingLogoPartnershipExplained,
};
